import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isUserLoggedSelector, isFirstLogin } from '../Redux/LoggedUserSlice';

export default function PrivateRoute({ component: Component, ...rest }) {
  const isUserLogged = useSelector(isUserLoggedSelector);
  const isFirstTime = useSelector(isFirstLogin);

  // 1. Manejar estado de carga: Si aún no se sabe si el usuario está logueado, no renderizar nada (o un spinner)
  if (isUserLogged === null) {
    return null; // O un componente de carga <LoadingSpinner />
  }

  return (
    <Route
      {...rest}
      render={props => {
        // 2. Si no está logueado, redirigir a Login
        if (!isUserLogged) {
          return <Redirect to="/login" />;
        }

        // 3. Si es el primer login y no está en la página de asignar contraseña, redirigir allí
        if (isFirstTime && props.location.pathname !== '/AssignPassword') {
          return <Redirect to="/AssignPassword" />;
        }

        // 4. Si NO es el primer login pero intenta acceder a la página de asignar contraseña, redirigir al dashboard
        if (!isFirstTime && props.location.pathname === '/AssignPassword') {
          return <Redirect to="/dashboard" />;
        }

        // 5. Si está logueado y las condiciones anteriores no aplican, renderizar el componente de la ruta privada
        return <Component {...props} />;
      }}
    />
  );
}
